import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ConnectionProvider } from "./context/ConnectionContext";
import AppLayout from "./components/layout/AppLayout";
import { PageLoader } from "./components/common/LoadingSpinner";

import LoginPage             from "./pages/LoginPage";
import DashboardPage         from "./pages/DashboardPage";
import AttendancePage        from "./pages/AttendancePage";
import AttendanceHistoryPage from "./pages/AttendanceHistoryPage";
import LeavePage             from "./pages/LeavePage";
// import PayslipPage           from "./pages/PayslipPage";
import ProfilePage           from "./pages/ProfilePageV2";
import AdminApp              from "./admin/AdminApp";

function PrivateRoute({ children }) {
  const { user, initializing } = useAuth();
  if (initializing) return <PageLoader />;
  return user ? children : <Navigate to="/login" replace />;
}

/** Area admin: wajib login DAN punya role manajerial (isAdmin). */
function AdminRoute({ children }) {
  const { user, initializing, isAdmin } = useAuth();
  if (initializing) return <PageLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, initializing } = useAuth();
  if (initializing) return <PageLoader />;
  return !user ? children : <Navigate to="/dashboard" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={
        <PublicRoute><LoginPage /></PublicRoute>
      } />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      <Route path="/dashboard" element={
        <PrivateRoute><AppLayout><DashboardPage /></AppLayout></PrivateRoute>
      } />
      <Route path="/attendance" element={
        <PrivateRoute><AppLayout><AttendancePage /></AppLayout></PrivateRoute>
      } />
      <Route path="/attendance/history" element={
        <PrivateRoute><AppLayout><AttendanceHistoryPage /></AppLayout></PrivateRoute>
      } />
      <Route path="/leave" element={
        <PrivateRoute><AppLayout><LeavePage /></AppLayout></PrivateRoute>
      } />
      {/* <Route path="/payslip" element={
        <PrivateRoute><AppLayout><PayslipPage /></AppLayout></PrivateRoute>
      } /> */}
      <Route path="/profile" element={
        <PrivateRoute><AppLayout><ProfilePage /></AppLayout></PrivateRoute>
      } />

      {/* Area admin (routes /admin/*). Punya layout sendiri (AdminLayout),
          bukan AppLayout karyawan. Dijaga role manajerial. */}
      <Route path="/admin/*" element={
        <AdminRoute><AdminApp /></AdminRoute>
      } />

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ConnectionProvider>
          <AppRoutes />
        </ConnectionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
